/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const legsEbonu3Components = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withAlias('LegsEbonu3').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/algu3d.glb',
            objectName: 'EBONU_ROUND_SUPPORT',
            dimensionUnit: 'm'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withAlias('LegsEbonu3').attach(memoEval((self)=>[
            self.$diameter,
            self.$height,
            self.$offsetZ
        ], ($diameter, $height, $offsetZ)=>({
            morphTargetInfluences: {
                Length: {
                    value: $diameter,
                    scaleOne: 3000,
                    scaleZero: 358
                },
                Width: {
                    value: $diameter,
                    scaleOne: 1300,
                    scaleZero: 358
                },
                Height: {
                    value: $height,
                    scaleOne: 780,
                    scaleZero: 740
                }
            },
            offsetZ: $offsetZ
        })))
];

//# sourceMappingURL=legs-ebonu-3.js.map